import { httpRequest } from "../../utils/HttpRequest";
import {
  ICashSearch,
  ICashDetail,
  ICashFields,
  ICashInsertFields,
  ICashUpdateFields,
  ICashCollect,
  ICashBatchCollect,
} from "./CashTypes";
import { IPage, IRet } from "../../types/FmsTypes";
interface IAccountType {
  abatementAmount?: string,           // null
  accountTypeCode?: string,           // "account-type.credit"
  accountTypeName?: string,           // "授信账户"
  availableAmount?: number,           // 0
  beCode?: string,           // "dhzd33"
  beName?: string,           // "德恒直达3"
  branch?: string,           // "ci"
  categoryCode?: string,           // null
  categoryName?: string,           // null
  code?: string,           // "ACC-PfeH-00000016"
  createTime?: string,           // "2021-02-20 14?:string,           //59?:string,           //43"
  creditAmount?: number,           // 0
  creditFlag?: number,           // 1
  key?: string,           // "3b1f307f1247fc58f49d69320e93238c"
  name?: string,           // "测试5"
  note?: string,           // null
  orgCode?: string,           // "yh.auto-service.pioneer"
  orgName?: string,           // "云豪创业空间"
  partnerCode?: string,           // "CUS-M-00000005"
  partnerName?: string,           // "上海繁沃汽车服务有限公司"
  partnerTypeCode?: string,           // "user-type.customer"
  remainingAmount?: number,           // 0
  status?: number,           // 0
  usedAmount?: number,           // 0
}
class CashService {
  //新增现金明细
  insert(param: ICashInsertFields) {
    const apiUrl = "/bill/cash/insert";
    return httpRequest
      .post<IRet<string>>(apiUrl, param);
  }
  //修改现金明细
  update(param: ICashUpdateFields) {
    const apiUrl = "/bill/cash/update";
    return httpRequest
      .post<IRet<string>>(apiUrl, param);
  }
  //删除现金明细
  delete(param: string) {
    const apiUrl = `/bill/cash/delete/${param}`;
    return httpRequest
      .post<IRet<string>>(apiUrl);
  }
  //确认现金明细
  confirm(param: string) {
    const apiUrl = `/bill/cash/confirm/${param}`;
    return httpRequest
      .post<IRet<string>>(apiUrl);
  }
  // 现金收付款款
  collect(param: ICashCollect) {
    const apiUrl = `/bill/cash`;
    return httpRequest
      .post<IRet<string>>(apiUrl, param);
  }
  //批量现金收付款款
  batchCollect(param: ICashBatchCollect) {
    const apiUrl = `/bill/cash/batch`;
    return httpRequest
      .post<IRet<string>>(apiUrl, param);
  }
  //账单查询(分页)
  page(param: ICashSearch) {
    const apiUrl = "/bill/cash/page";
    return httpRequest
      .post<IPage<ICashDetail>>(apiUrl, param);
  }
  //查询特定得收款账户
  accountFind(param: object) {
    const apiUrl = "/account/find";
    return httpRequest
      .post<IPage<IAccountType>>(apiUrl, param);
  }
}

export const cashService = new CashService();
